import { GET_MOTIVO, ADD_MOTIVO, MODIFY_MOTIVO, DELETE_MOTIVO, UPDATE_MOTIVO } from '../constants/action_types';

const initialState = {
    motivos: [],
    isLoading: false
};


export function getDescr(value)
{
    const tipos = ['','Cliente inactivo', 'Movimiento autoriz.'];
    return tipos[value ? value : 1]
}

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MOTIVO:
            
            return {
                ...state,
                isLoading: true
            };

        case GET_MOTIVO + "_SUCCESS":
            const newMotivo = action.payload.data.map(p => {
                return {...p, kindDescr: getDescr(p.iKind)}
             })

            return {
                motivos: newMotivo, // action.payload.data,
                isLoading: false
            };

        case ADD_MOTIVO:
            
            const newArr = [...state.motivos, action.payload]
            return {
                motivos: newArr,
                isLoading: false
            };

        case MODIFY_MOTIVO:

            return {
                motivos: state.motivos.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return {...action.payload, kindDescr: getDescr(action.payload.iKind)};
                }),
                isLoading: false
            };

        case DELETE_MOTIVO:

            return {
                motivos: state.motivos.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_MOTIVO + "_SUCCESS":

            return state;

        default:

            return state;
    }
}